'use client'

import {
  AuthFlowType,
  B2BOAuthProviders,
  B2BProducts,
  StytchB2BUIConfig,
  StytchEvent
} from '@stytch/vanilla-js'
import { StytchB2B } from '@stytch/nextjs/b2b'
import { stytchClientConfig } from '../stytch'
import { stytchB2bClient } from '../stytch/stytch-b2b-client'
import { clearPostLoginRedirect, getPostLoginRedirect } from '../utils/post-login-redirect'

const strings = {
  'provider.continueWithSSO': 'Login with OpenLoop'
}

export const getDiscoveryConfig = (): StytchB2BUIConfig => {
  // Query string example: ?b2b-products=sso,passwords
  let b2bProducts = [B2BProducts.sso, B2BProducts.passwords]

  const redirectOrigin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : stytchClientConfig.redirectUrl
  const loginRedirectURL = `${redirectOrigin}/login`

  if (typeof window !== 'undefined') { // client-only
    const queryProducts = new URLSearchParams(window.location.search).get('b2b-products')
    if (queryProducts) {
      b2bProducts = queryProducts.split(',').map(x => x.trim()) as B2BProducts[]
    }
  }

  return {
    products: b2bProducts ?? [B2BProducts.sso],
    sessionOptions: { sessionDurationMinutes: 60 },
    passwordOptions: {
      loginRedirectURL,
      resetPasswordRedirectURL: `${redirectOrigin}/login/password-reset`,
      resetPasswordExpirationMinutes: 20
    },
    ssoOptions: {
      loginRedirectURL,
      signupRedirectURL: loginRedirectURL
    },
    oauthOptions: {
      providers: [B2BOAuthProviders.Google],
      loginRedirectURL,
      signupRedirectURL: loginRedirectURL,
      discoveryRedirectURL: loginRedirectURL
    },
    authFlowType: AuthFlowType.Discovery
  }
}

const styles = {
  container: {
    backgroundColor: '',
    borderColor: 'none'
  },
  colors: {
    // primary: '#041c40',
    primary: '#fff',
    secondary: '#fff'
  },
  buttons: {
    primary: {
      backgroundColor: '#fef983',
      textColor: '#041c40',
      borderRadius: '8px'
    },
  },
  inputs: {
    borderColor: '#8587e9'
  },
  fontFamily: 'Gilroy',
  hideHeaderText: false
}

const callbacks = {
  onEvent: (e: StytchEvent) => {
    console.debug('stytch:onEvent', e)
    if (e.type === 'AUTHENTICATE_FLOW_COMPLETE') {
      // Check if this page is loaded in a popup
      const isPopup = window.opener && window.opener !== window

      if (isPopup) {
        const tokens = stytchB2bClient.session.getTokens()
        // Send session data to parent window
        window.opener.postMessage(
          {
            type: 'AUTH_SUCCESS',
            data: tokens
          },
          window.location.origin
        )

        // Close the popup
        window.close()
      } else {
        // Normal redirect for non-popup
        const target = getPostLoginRedirect('/')
        clearPostLoginRedirect()
        window.location.href = target
      }
    }
  }
}

export const HappyStytchB2B = () => (
  <StytchB2B
    config={getDiscoveryConfig()}
    styles={styles}
    callbacks={callbacks}
    strings={strings}/>
)
